<template>
<div v-loading="loading"  element-loading-text="数据加载中..." style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%">
      <el-main style="padding: 0;width:90%;height: 100%;margin-left: 2px;overflow-x: hidden;overflow-y: hidden">
        <div class="border center" style="text-align: left;margin-left: 5px;">
          <el-button size="small" class="week" style="margin-left: 20px" @click="clickThisWeek">{{ $t('makeSchedule.paintingProductionScheduling.thisWeek') }}</el-button>
          <el-button size="small" class="week" style="margin-left: 30px" @click="clickLastWeek"><el-icon><ElIconArrowLeft /></el-icon>{{ $t('makeSchedule.paintingProductionScheduling.lastWeek') }}</el-button>
          <el-date-picker size="small" v-model="week" format="M月-D日" value-format="MM-DD" type="daterange" disabled range-separator="~" style="width: 180px;"/>
          <el-button size="small" class="week" @click="clickNextWeek">{{ $t('makeSchedule.paintingProductionScheduling.afterWeek') }}<el-icon><ElIconArrowRight /></el-icon></el-button>
        </div>
        <div ref="total_height" style="display: flex;height: 96%;width: auto;overflow-x: auto;">
          <div class="total_style" v-for="item in state.dataList" :key="item">
            <div class="border color time" :style="item.expireTimeClass">
              <div>{{ item.time }}</div>
              <div>{{ item.week }}</div>
            </div>
            <div v-if="!item.line_bool" :class="!item.line_bool?'prompt data_style1':''" :style="maxHeight">产线未开</div>
            <div v-if="item.line_bool" class="data_style">
              <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2" :style="item.expireTimeClass">
                <div class="data_style3">
                  <span v-if="lineCnt.dayShiftCnt == 'powder'" style="background-color: burlywood" class="data_style4">&nbsp;粉体&nbsp;</span>
                  <span v-if="lineCnt.dayShiftCnt == 'liquid'" style="background-color: #0486fe" class="data_style4">&nbsp;液体&nbsp;</span>
                  <span v-if="lineCnt.dayShiftCnt == 'pretreatment'" style="background-color: #2bd82f" class="data_style4">&nbsp;前处理&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt == 'powder'" style="background-color: burlywood" class="data_style4_1">&nbsp;粉体&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt == 'liquid'" style="background-color: #0486fe" class="data_style4_1">&nbsp;液体&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt == 'pretreatment'" style="background-color: #2bd82f" class="data_style4_1">&nbsp;前处理&nbsp;</span>
                </div>
                <div :class="lineCnt.class_name" :style="dayMaxLineHeight[lineCnt.class_name]">
                  <div v-if="lineCnt.remark != '' && lineCnt.remark != undefined" style="margin-bottom: 2px;" class="item">{{ lineCnt.remark }}</div>
                  <draggable :style="lineCnt.height" :class="lineCnt.class_line_name" :list="lineCnt.lineData"
                             ghost-class="ghost" handle=".move" chosen-class="chosenClass" animation="300"
                             :sort="true" group="group">
                    <template #item="{ element }">
                      <div class="item">
                        <el-row style="border-bottom: #0478e4 2px solid">
                          <el-col :span="24">
                            <span>{{ element.wujian_short_name }}&nbsp;-&nbsp;</span>
                            <span>{{ element.floor }}F&nbsp;-&nbsp;</span>
                            <span>{{ paint_type_name[element.paint_type]}}</span>
                          </el-col>
                          <div style="margin-top: -22px;margin-left: 92%;">
                                <span @click="splitBatchItem(item.time,lineCnt,element)" class="cursor"
                                      style="font-size: 14px;"><el-icon><ElIconMoreFilled/></el-icon></span>
                          </div>
                        </el-row>

                        <el-row :style="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'?'border-bottom: #0478e4 2px solid':''">
                          <el-col v-for="batchNo in element.batchData" :key="batchNo" :span="12">
                            <div>{{ batchNo }}</div>
                          </el-col>
                        </el-row>
                        <el-row v-if="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'">
                          <el-col v-for="color in element.colorData" :key="color" :span="12">
                            <div>{{ color }}</div>
                          </el-col>
                        </el-row>
                      </div>
                    </template>
                  </draggable>
                </div>

              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>


  <el-dialog title="详情" v-model="splitBatchItemBool" width="60%">
    <el-form :model="formWujianData" label-width="100px">
      <el-row>
        <el-col :span="24">
          <div style="text-align: center;font-size: 30px;height: 50px">{{formWujianData.wujian_short_name}}</div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="楼层信息：">
            <el-input v-model="formWujianData.floor"  disabled placeholder="楼层信息" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="排产日期：">
            <el-date-picker v-model="formWujianData.production_scheduling_date" disabled type="date" placeholder="排产日期" style="width: 90%"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排产产线：">
            <div v-if="!lineBool && formWujianData.lineCnt == 'powder'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">粉体白班</div> <!--  白班-->
            <div v-if="!lineBool && formWujianData.lineCnt == 'liquid'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">液体白班</div> <!--  白班-->
            <div v-if="!lineBool && formWujianData.lineCnt == 'pretreatment'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">前处理白班</div> <!--  白班-->
            <div v-if="lineBool && formWujianData.lineCnt == 'powder'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">粉体夜班</div> <!--  夜班-->
            <div v-if="lineBool && formWujianData.lineCnt == 'liquid'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">液体夜班</div> <!--  夜班-->
            <div v-if="lineBool && formWujianData.lineCnt == 'pretreatment'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">前处理夜班</div> <!--  夜班-->
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="排产批号：">
            <el-select disabled style="width: 95%;" v-model="formWujianData.newBatchNoList" multiple filterable clearable placeholder="物件名称">
              <el-option v-for="item in this.batchNoList" :key="item.id" :label="item.batch_no + ' - ' + item.color" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>

</template>
<script>
import draggable from "vuedraggable";
import moment from "moment";

export default {
  name: "PaintingTotalPlan",
  components: {draggable},
  data() {
    return {
      assemblyEndTime:'',
      batchNoList: [],//修改前的批号数据
      state:{
        dataList:[],
      },
      startTime:'',
      endTime:'',
      week: [], //时间组件数据
      weekList: [], //一个星期的时间
      splitBatchItemBool: false, //控制物料详情页面
      formWujianData: {},
      lineBool:false,//false表示白班 true表示夜班
      loading:false,
      maxHeight: "",//获取页面的最大高度
      dayMaxLineHeight:{},
      paint_type_name:{
        'ft': '粉体',
        'fs': '液体',
        'acl': '共通'
      },
      classNameList: ['pretreatment','powder','liquid'],
    }
  }, methods: {
    async getCalendarLineDataAll(startTime, endTime, weekList) {
      this.loading = true;
      let params = {startTime:startTime, endTime:endTime, weekList:weekList}
      this.$axios.post('mfg/paintingProduction/getCalendarLineDataAll', params).then(response => {
        let res = response.data
        if (res.code !== 0){
          this.loading = false;
          return this.$message.error(res.message);
        }
        this.state.dataList = res.data;
        this.maxHeight = '';
        this.dayMaxLineHeight = {};
        this.loading = false;
        setTimeout(async () => {
          await this.getMaxHeight();
        }, 200)
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    //物件计划详情
    splitBatchItem(time,lineCnt,element) {
      this.batchNoList = element.newBatchNoList;
      this.splitBatchItemBool = true;
      let cnt;
      if (lineCnt.dayShiftCnt) {
        cnt = lineCnt.dayShiftCnt;
        this.lineBool = false;
      } else {
        cnt = lineCnt.nightShiftCnt;
        this.lineBool = true;
      }

      this.formWujianData.wujian_short_name = element.wujian_short_name;
      this.formWujianData.floor = element.floor;
      this.formWujianData.newBatchNoList = [];
      for (let batchNo of element.newBatchNoList) {
        this.formWujianData.newBatchNoList.push(batchNo.id)
      }

      this.formWujianData.lineCnt = cnt;
      let timeString = time.toString().substring(0,time.toString().length - 1);
      let timeList = timeString.toString().split("月");
      let month = timeList[0];
      let day = timeList[1];
      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }
      let date;
      //特殊处理跨年的
      if (this.startTime.substring(0,4) !== this.endTime.substring(0,4)) {
        if (parseInt(month) < 12) { //这是下一年
          date = this.endTime.substring(0,4) + '-' + month + '-' + day;
        } else {
          date = this.startTime.substring(0,4) + '-' + month + '-' + day;
        }
      } else {
        date = this.startTime.substring(0,4) + '-' + month + '-' + day;
      }
      this.formWujianData.production_scheduling_date = date;
    },
    //本周
    clickThisWeek() {
      this.loading = true;
      let obj = this.getCurrWeekDays();
      this.formatTime(obj.startTime,obj.endTime);
    },
    //上周
    clickLastWeek() {
      this.loading = true;
      let obj = this.getLastWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime,obj.endTime);
    },
    //下周
    clickNextWeek() {
      this.loading = true;
      let obj = this.getBelowWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime,obj.endTime);
    },
    // 获取本周开始结束时间
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      let endDate = new Date(this.assemblyEndTime); // 结束日期
      obj.startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      obj.endTime = moment(endDate.valueOf()).format('YYYY-MM-DD');
      return obj
    },
    // 获取上一周的开始结束时间
    getLastWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(-7,'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(-7,'days').format('YYYY-MM-DD');
      return obj
    },
    // 获取下一周的开始结束时间
    getBelowWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(7,'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(7,'days').format('YYYY-MM-DD');
      return obj
    },
    //处理时间
    async formatTime(startTime, endTime) {
      console.log("startTime=",startTime)
      console.log("endTime=",endTime)
      this.startTime = startTime;
      this.endTime = endTime;
      this.week = [];
      this.weekList = [];
      let startDate = moment(startTime).add(-1,'days');
      let endDate = moment(endTime);
      while (startDate.isBefore(endDate)) {
        startDate.add(1,'days');
        let date = moment(startDate).format('YYYY-MM-DD')
        let time = moment(date).format('MM') + "月" + moment(date).format('DD') + "日";
        this.weekList.push({time});
      }

      let weeks = ["一","二","三","四","五","六","日"]
      let cnt = 0;
      for (let i = 0; i < this.weekList.length; i++) {
        if (i === 7) {
          cnt = 0;
        }
        this.weekList[i]['week'] = "(" + weeks[cnt] + ")";
        cnt += 1;
      }

      this.week.push(moment(startTime).format('MM') + "-" + moment(startTime).format('DD'));
      this.week.push(moment(endTime).format('MM') + "-" + moment(endTime).format('DD'));
      await this.getCalendarLineDataAll(startTime, endTime, this.weekList)
    },
    async getAssemblyEndTime(){
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/paintingProduction/getAssemblyEndTime',params).then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime,obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    async getMaxHeight() {
      var h_max1 = 0;
      for (let value of this.classNameList) {
        let name = "day_class_" + value;
        var widthBox = document.getElementsByClassName("day_class_" + value + "");
        if (widthBox != undefined && widthBox.length > 0) {
          let h_max = 0;
          for (let i = 0; i < widthBox.length; i++) {
            if (h_max < widthBox[i].clientHeight) {
              h_max = widthBox[i].clientHeight;
            }
          }

          this.dayMaxLineHeight[name] = "height: " + (h_max) + "px;";
          h_max1 += h_max + 36;
        }
      }

      this.maxHeight = "height: " + h_max1 + "px;";
    },
  },created() {
    this.getAssemblyEndTime();
  }
}
</script>

<style scoped>
.border {
  border:rgb(216, 220, 230) 1px solid;
}

.color {
  background-color: #e7e7e7;
}

.center {
  text-align: center;
  line-height: 32px;
}

.cursor {
  cursor: pointer;
}

/*一下是拖拽样式*/
.item {
  margin-bottom: 2px;
  border: solid 2px #0478e4;
  font-size: 14px;
  color: black;
  height: auto;
  text-align: center;
  background-color: whitesmoke;
}

.is_other_wujian_style {
  border: solid 2px #8a9197 !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: whitesmoke;
}

.item1 {
  border-top: dashed 1px #a9aeb7 !important;
  font-size: 14px;
  color: black;
  text-align: center;
  background-color: whitesmoke;
}

.item2 {
  border: solid 2px #0478e4 !important;
  font-size: 6px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color:  #e7e7e7;
}

.item2:hover {
  background-color: whitesmoke;
}

.chosenClass {
  font-size: 13px;
  font-weight: bold;
}

/*button样式*/
.button {
  color: white;
  border-radius: 5px 5px 0 0;
  width: 100%;
  margin-top: 5px;
}

/*div样式*/
.week {
  border: #909399 0 solid;background-color: white; color: rgb(4, 134, 254);
}

.total_style {
  width:auto;
  align-items:center;
  margin-left: 5px;
  margin-top: 1px;
}

.time {
  width:100%;
  text-align: center;
  margin-top: 5px;
}

.data_style {
  width:224px;
  height: auto;
}

.data_style1 {
  width:224px;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 5px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  margin-top: 5px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width:100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.data_style4 {
  background-color: #0478e4;
  font-size: 14px;
}

.data_style4_1 {
  background-color: black;
  margin-left: 2px;
  font-size: 14px;
}

.scrollbar::-webkit-scrollbar{
  display: none;
}

.prompt {
  color:rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.initHeight {
  border: #d8dce6 2px solid;
  height: 50px;
}


</style>